/**
 * Gorjeta / taxa de serviço — leitura da config e cálculo.
 *
 * A config vem no objeto `empresa` do login (está em EMPRESA_SAFE_FIELDS no
 * backend), então NÃO existe chamada de API aqui. Isso é de propósito: o
 * endpoint de configuração exige permissão de `informacoes_loja`, que o garçom
 * normalmente não tem — buscar por lá quebraria para o perfil que mais usa esta
 * tela.
 *
 * Espelhado em garcomapp-front/src/utils/gorjeta.js.
 */
import { getMoneyCtx } from './currency';
import { roundToCurrency } from './currencyCatalog';

const CFG_DESLIGADA = {
    habilitado: false,
    percentual: 0,
    modo: 'sugerida',
    aplica_em: [],
};

/** Config vigente da empresa. Nunca lança; desligada é o fallback. */
export function getGorjetaConfig() {
    try {
        const raw = localStorage.getItem('empresa');
        const g = raw ? JSON.parse(raw)?.configuracoes?.gorjeta : null;
        if (!g || g.habilitado !== true) return CFG_DESLIGADA;

        const pct = Number(g.percentual);
        if (!Number.isFinite(pct) || pct <= 0) return CFG_DESLIGADA;

        return {
            habilitado: true,
            percentual: pct,
            modo: g.modo === 'fixa' ? 'fixa' : 'sugerida',
            aplica_em: Array.isArray(g.aplica_em) && g.aplica_em.length ? g.aplica_em : ['mesa'],
        };
    } catch {
        return CFG_DESLIGADA;
    }
}

/** A gorjeta se aplica a este canal? ('mesa' | 'balcao' | 'delivery') */
export function gorjetaAplicaEm(canal, cfg = getGorjetaConfig()) {
    return cfg.habilitado && cfg.aplica_em.includes(canal);
}

/**
 * Calcula a gorjeta sobre um valor de consumo.
 *
 * Arredonda na granularidade da MOEDA BASE, não em 2 casas fixas: em lira não
 * existe centavo, então 10% de 895.555 tem que virar 89.556 e não 89.555,50.
 *
 * O percentual incide sobre o consumo na moeda base — nunca sobre um valor já
 * convertido, senão dois arredondamentos em sequência divergem do total real.
 */
export function calcularGorjeta(valorConsumo, cfg = getGorjetaConfig()) {
    if (!cfg.habilitado) return 0;
    const base = Number(valorConsumo) || 0;
    if (base <= 0) return 0;
    return roundToCurrency((base * cfg.percentual) / 100, getMoneyCtx().base);
}
